// extracted by mini-css-extract-plugin
export default {"search":"CustomSearch_search__afDuS"};